(() => {
  const initAOS = () => {
    if (typeof window.AOS === 'undefined') return;

    window.AOS.init({
      duration: 700,
      easing: 'ease-out-cubic',
      once: true,
      offset: 80,
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
    });

    const refreshAOS = () => window.requestAnimationFrame(() => window.AOS?.refreshHard());

    if (document.readyState === 'complete') {
      refreshAOS();
    } else {
      window.addEventListener('load', refreshAOS, { once: true });
    }
  };

  initAOS();

  document.addEventListener('shopify:section:load', () => {
    window.AOS?.refreshHard();
  });
})();
